import React from 'react'
import { Navbar } from 'react-bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import { Link } from 'gatsby'

const Logo = () => {
  return (
    <Navbar expand="lg">
      <Navbar.Text style={{ width: '100%' }}>
        <Link to="/" style={{ textDecoration: 'none' }}>
          <span>
            <h2 className="logo">
              covid<span style={{ color: 'var(--cvc-green)' }}>vax</span>count
            </h2>
          </span>
        </Link>
      </Navbar.Text>
    </Navbar>
  )
}

export default Logo
